import React from 'react';
import { SignInPageLayout } from '../layout/SignInPageLayout';
import { AutoConfirm } from '../component/auto-confitm/AutoConfirm';

export const AutoConfirmPage = () => (
  <SignInPageLayout centerDesktop={<AutoConfirm />} />
);
